// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"78f8ec1b","732":"8ee4e2bb","977":"a9c5dbff"}[chunkId] + ".chunk.js";
};